export default {
  mounted() {
    //加载百度统计代码
    // this.loadTongji();
  },
  methods: {
    loadTongji() {
      var _hmt = _hmt || [];
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?4d0dc6f12dfefa731a23f220017407c3";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    },
  },
};
